import React, { ReactElement } from 'react';
import { Alert } from 'b2b-components/theme/components/Alert';
import { ContentAlertProps } from 'b2b-apps/shop/common/components';
import { ContentControlButtons } from '../ContentControlButtons';
import './ContentAlert.scss';

export const ContentAlert = ({ text, alertType, onClose, onConfirm }: ContentAlertProps): ReactElement => (
  <>
    <h5 className='ContentFail-Title'>{text.title}</h5>

    <div className='Modal-ContentAlert'>
      <Alert
        displayType={Alert.config.displayType.text}
        styleType={alertType}
      >
        {text.content}
      </Alert>
    </div>

    <ContentControlButtons
      onClose={onClose}
      closeLabel={text.closeLabel}
      onConfirm={onConfirm}
      confirmLabel={text.confirmLabel}
    />
  </>
);
